<ng-container *ngIf="dataLoading && items.length == 0">
    <div class="content-centered-column">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!dataLoading || items.length">
    <div class="header">
        <ion-row class="ion-no-padding">
            <ion-col size="5">
                <p class="title">{{ 'DASHBOARD_NEWSFEED' | trns }}</p>
            </ion-col>
            <ion-col size="7"
                     class="ion-text-right">
                <span (click)="showFilter($event)"
                      class="open-filter"
                      color="secondary">
                    {{ getSelectedFilter()?.title }}
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-arrow.svg"
                              class="collapsible">
                    </svg-icon>
                </span>
            </ion-col>
        </ion-row>
    </div>
    <ng-container *ngFor="let item of items; let c = index">

        <newsfeed-detail *ngIf="item.id != editId"
                         [newsfeed]="item"
                         (onDelete)="newsfeedDeleted($event)"
                         [showKeywords]="showKeywords"
                         [event]="event">
        </newsfeed-detail>

    </ng-container>

    <ion-infinite-scroll *ngIf="!detail"
                         threshold="100px"
                         (ionInfinite)="loadData($event)">
        <ion-infinite-scroll-content loadingSpinner="bubbles"
                                     [loadingText]="'NEWSFEED_LIST_LOADING_MORE' | trns">
        </ion-infinite-scroll-content>
    </ion-infinite-scroll>
</ng-container>